export default {"src":"/_next/static/media/frame1.07009497.svg","height":109,"width":238,"blurWidth":0,"blurHeight":0};